import Vue from "vue";
import Router from "vue-router";
import Main from "../components/Main";
import DetailPage from "../components/detail/DetailPage";
import ListPage from "../components/list/ListPage";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            component: Main,
            meta: {scrollToTop: true}
        },
        {
            path: "/privacy-policy/:id",
            component: DetailPage,
            meta: {scrollToTop: true}
        },
        {
            path: "/cookie-policy/:id",
            component: DetailPage,
            meta: {scrollToTop: true}
        },
        {
            path: "/terms-and-conditions/:id",
            component: DetailPage,
            meta: {scrollToTop: true}
        },
        {
            path: "/service/:id",
            component: DetailPage,
            meta: {scrollToTop: true}
        },
        {
            path: "/publications",
            component: ListPage,
            meta: {scrollToTop: true}
        },
        {
            path: "/publications/:id",
            component: DetailPage,
            meta: {scrollToTop: true}
        },
        {
            path: "/portfolio",
            component: ListPage,
            meta: {scrollToTop: true}
        },
        {
            path: "/portfolio/:id",
            component: DetailPage,
            meta: {scrollToTop: true}
        },
        {
            path: "/guided-tours",
            component: ListPage,
            meta: {scrollToTop: true}
        },
        {
            path: "/guided-tours/:id",
            component: DetailPage,
            meta: {scrollToTop: true}
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});
